import axios from "axios";
import { api } from "./helper";
import store from "../../store/store";
import { v4 as uuidv4 } from "uuid";

function prepareDataRequest(data) {
  return { RequestCorrelationId: uuidv4(), Data: data };
}
export function prepareRequest(data) {
  return { ...data, RequestCorrelationId: uuidv4() };
}

const client = axios.create({ baseURL: api, withCredentials: false });
client.interceptors.request.use((config) => {
  config.headers.Authorization = "Bearer " + store.state.user.jwt;
  return config;
});

function CreateCourtPreparation(item) {
  return client.post("CourtPreparations/CreateCourtPreparation", prepareDataRequest(item));
}
function UpdateCourtPreparation(item) {
  return client.post("CourtPreparations/UpdateCourtPreparation", prepareDataRequest(item));
}
function GetCourtPreparation(subrogationId, participantId) {
  return client.post("CourtPreparations/GetCourtPreparation/", prepareRequest({ subrogationId, participantId }));
}
function GetPreCourtLetter(subrogationId) {
  return client.post("PreCourtLetters/GetPreCourtLetter/", prepareRequest({ subrogationId }));
}

export {
  CreateCourtPreparation,
  UpdateCourtPreparation,
  GetCourtPreparation,
  GetPreCourtLetter,
}
